import { Card, Tabs } from "antd";
import { t } from "i18next";
import AppointmentDataGrid from "./AppointmentDataGrid";
import AppointmentFilter from "./AppointmentFilter";
import moment from "moment";
import { DataGridProvider } from "../../../core/components/data-grid/DataGridContext";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import { useHistory } from "react-router-dom";
import Helper from "../../../core/Helper";
import React, { useEffect, useState } from "react";
import { PERMISSIONS, useUser } from "../../../core/context/UserContext";
import AppointmentEntitlementDataGrid from "../appointment-entitlement/AppointmentEntitlementDataGrid";
import AppConfig from "../../../core/service/AppConfig";
import AppointmentAccountingDataGrid from "../appointment-accounting/AppointmentAccountingDataGrid";

export default function AppointmentDataGridApp() {
    const [view, setView] = useState('appointment')
    const history = useHistory()
    const { hasPermission } = useUser()

    const filter = Helper.UrlParams.getUrlParamAsObject(window.location.search);
    if (filter) {
        if (filter.startDate) {
            filter.startDate = moment(filter.startDate);
        }

        if (filter.endDate) {
            filter.endDate = moment(filter.endDate);
        }

        if (filter.hasBalance !== undefined) {
            filter.hasBalance = filter.hasBalance === 'true';
        }
    }

    useEffect(() => {
        document.title = `${t('Appointments')} - ${AppConfig.getHisTitle()}`;

        // ResizeObserver loop limit exceeded hatasını gizle (AntD Tabs/Table kaynaklı)
        const resizeObserverLoopErr = 'ResizeObserver loop limit exceeded';
        const _error = window.console.error;
        window.console.error = (...args) => {
            if (typeof args[0] === 'string' && args[0].includes(resizeObserverLoopErr)) {
                return;
            }
            _error(...args);
        };

        return () => {
            window.console.error = _error;
        }
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <DataGridProvider
                defaultFilter={{
                    startDate: moment(),
                    endDate: moment(),
                    isDeleted: false,
                    dateFilterType: 'appointmentDate',
                    hasBalance: false,
                    ...filter
                }}
            >
                <Card>
                    <AppointmentFilter view={view} />
                    <Tabs
                        style={{ marginTop: 8 }}
                        onChange={(val) => setView(val)}
                        type="card"
                    >
                        <Tabs.TabPane tab={t('Appointments')} key={'appointment'} />
                        {
                            hasPermission(PERMISSIONS.ENTITLEMENT_VIEW) && (
                                <Tabs.TabPane tab={t('Entitlement')} key={'entitlement'} />
                            )
                        }
                        {
                            hasPermission(PERMISSIONS.APPOINTMENT_ACCOUNTING) && (
                                <Tabs.TabPane tab={t('Accounting')} key={'accounting'} />
                            )
                        }

                    </Tabs>
                    {
                        view === 'appointment' && (<AppointmentDataGrid />)
                    }
                    {
                        view === 'entitlement' && hasPermission(PERMISSIONS.ENTITLEMENT_VIEW) && (<AppointmentEntitlementDataGrid />)
                    }
                    {
                        view === 'accounting' && hasPermission(PERMISSIONS.APPOINTMENT_ACCOUNTING) && (<AppointmentAccountingDataGrid />)
                    }

                </Card>
            </DataGridProvider>
        </SimpleLayout>
    )
}